// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".withdrawalRecord[data-v-3f0eb25d]{margin:0 auto;margin-top:1.041667rem;margin-bottom:.9375rem;background-color:#fff;padding-bottom:.520833rem;width:62.239583rem}.el-table[data-v-3f0eb25d]{min-height:26.041667rem}.el-pagination[data-v-3f0eb25d]{text-align:right}.title[data-v-3f0eb25d]{font-size:1.041667rem;padding:.520833rem}", ""]);
// Exports
module.exports = exports;
